"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
function checkIsMatchActive(matchStatus, isDisabled, betStop // TODO: Make betStop require.
) {
    return ((matchStatus === types_1.GQL.SportEventStatus.NOT_STARTED ||
        matchStatus === types_1.GQL.SportEventStatus.LIVE) &&
        !isDisabled &&
        !betStop);
}
exports.default = checkIsMatchActive;
//# sourceMappingURL=checkIsMatchActive.js.map